/* Hisola owned UI behaviour (HIS-113): swipe strips with dots/arrows/rotation and the sticky
   add-to-cart bar. Loaded with defer by several sections; the guard keeps it single-instance. */
(function () {
  if (window.HisolaUI) return;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Splide's default slide transition (400ms, cubic-bezier(0.25, 1, 0.5, 1)), which the store's previous theme used
  // for its strips (HIS-118: measured with document.getAnimations() on its render).
  var SLIDE_MS = 400;
  function bezier(x1, y1, x2, y2) {
    var cx = 3 * x1, bx = 3 * (x2 - x1) - cx, ax = 1 - cx - bx;
    var cy = 3 * y1, by = 3 * (y2 - y1) - cy, ay = 1 - cy - by;
    function sx(t) { return ((ax * t + bx) * t + cx) * t; }
    function sy(t) { return ((ay * t + by) * t + cy) * t; }
    function dx(t) { return (3 * ax * t + 2 * bx) * t + cx; }
    return function (x) {
      var t = x;
      for (var i = 0; i < 8; i++) {
        var e = sx(t) - x;
        if (Math.abs(e) < 1e-6) return sy(t);
        var d = dx(t);
        if (Math.abs(d) < 1e-6) break;
        t -= e / d;
      }
      var lo = 0, hi = 1;
      t = x;
      while (hi - lo > 1e-7) {
        var v = sx(t);
        if (Math.abs(v - x) < 1e-6) break;
        if (x > v) lo = t; else hi = t;
        t = (lo + hi) / 2;
      }
      return sy(t);
    };
  }
  var slideEase = bezier(0.25, 1, 0.5, 1);

  function initSlider(root) {
    if (root.dataset.hisolaReady) return;
    var track = root.querySelector('[data-hisola-track]');
    if (!track) return;
    root.dataset.hisolaReady = 'true';
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hisola-slide]'));
    var dots = root.querySelector('[data-hisola-dots]');
    var prev = root.querySelector('[data-hisola-prev]');
    var next = root.querySelector('[data-hisola-next]');
    var timer = null;
    var frame = null;

    // Where the track must scroll for a slide to sit at its start edge (the track's padding is the gutter).
    function offsetOf(slide) {
      return slide.offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    }
    function current() {
      var left = track.scrollLeft, best = 0, bestDistance = Infinity;
      slides.forEach(function (slide, index) {
        var distance = Math.abs(offsetOf(slide) - left);
        if (distance < bestDistance) { best = index; bestDistance = distance; }
      });
      return best;
    }
    function scrollToLeft(left) {
      if (frame) window.cancelAnimationFrame(frame);
      var start = track.scrollLeft, delta = left - start, t0 = null;
      if (Math.abs(delta) < 1) return;
      if (reducedMotion) { track.scrollLeft = left; return; }
      // Each frame sets the position itself: no snapping and no smooth scrolling meanwhile (a smooth scroll started
      // by one frame would be cancelled by the next, and the strip would hardly move).
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      function step(t) {
        if (t0 === null) t0 = t;
        var progress = Math.min(1, (t - t0) / SLIDE_MS);
        track.scrollLeft = start + delta * slideEase(progress);
        if (progress < 1) { frame = window.requestAnimationFrame(step); return; }
        frame = null;
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = '';
      }
      frame = window.requestAnimationFrame(step);
    }
    function go(index) {
      if (!slides.length || index < 0 || index > slides.length - 1) return;
      scrollToLeft(offsetOf(slides[index]));
    }
    // Adaptive height (reviews): the strip is as tall as its current slide, as on the previous theme.
    var adaptive = root.hasAttribute('data-adaptive-height');
    function fit() {
      if (!adaptive || !slides.length) return;
      track.style.height = slides[current()].offsetHeight + 'px';
    }
    function paint() {
      var active = current();
      fit();
      // Like the previous theme's strips, the arrows rest at the first and last slide (no wrap-around).
      if (prev) prev.disabled = active <= 0;
      if (next) next.disabled = active >= slides.length - 1;
      if (!dots) return;
      // No dots when every slide is already in view (the previous theme showed none then).
      dots.style.display = track.scrollWidth > track.clientWidth + 1 ? '' : 'none';
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
    }
    if (dots && slides.length > 1) {
      slides.forEach(function (_, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hisola-slider__dot';
        dot.setAttribute('aria-label', String(index + 1) + ' / ' + String(slides.length));
        dot.addEventListener('click', function () { go(index); });
        dots.appendChild(dot);
      });
    }
    paint();
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', function () { window.requestAnimationFrame(paint); });
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });

    // Rotation stops at the last slide, as the previous theme's did.
    var delay = Number(root.dataset.autoplay || 0);
    if (delay > 0 && !reducedMotion && slides.length > 1) {
      var stop = function () { if (timer) window.clearInterval(timer); timer = null; };
      var start = function () {
        stop();
        timer = window.setInterval(function () {
          var active = current();
          if (active >= slides.length - 1) { stop(); return; }
          go(active + 1);
        }, delay);
      };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('touchstart', stop, { passive: true });
      start();
    }
  }

  function initSticky(bar) {
    if (bar.dataset.hisolaReady) return;
    var form = document.getElementById(bar.dataset.formId);
    var mainButton = form && form.querySelector('[type="submit"][name="add"]');
    if (!mainButton) return;
    bar.dataset.hisolaReady = 'true';
    var button = bar.querySelector('[data-hisola-sticky-button]');
    var price = bar.querySelector('[data-hisola-sticky-price]');
    var priceRoot = document.getElementById('price-' + bar.dataset.sectionId);

    var fixed = bar.getAttribute('data-hisola-label');

    function mirror() {
      var label = mainButton.querySelector('span');
      var disabled = mainButton.hasAttribute('disabled') || mainButton.getAttribute('aria-disabled') === 'true';
      if (button && label) button.textContent = fixed && !disabled ? fixed : label.textContent.trim();
      if (button) button.disabled = disabled;
      if (price && priceRoot) {
        var onSale = priceRoot.querySelector('.price--on-sale');
        var item = onSale ? priceRoot.querySelector('.price__sale .price-item--last') : priceRoot.querySelector('.price__regular .price-item--regular');
        if (item && item.textContent.trim()) price.textContent = item.textContent.trim();
      }
    }
    mirror();
    var observer = new MutationObserver(mirror);
    observer.observe(mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceRoot) observer.observe(priceRoot, { childList: true, subtree: true, characterData: true });

    function show(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (button) button.tabIndex = visible ? 0 : -1;
    }
    // Shown only once the main button has scrolled above the viewport. A scroll listener (not an
    // IntersectionObserver) so a jump from below the button to above it, or back, is never missed.
    var queued = false;
    function update() {
      queued = false;
      show(mainButton.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Fixed per-template button label (live theme behaviour). Dawn writes the visitor-language
  // "Add to cart" text back on every variant change; while the button is enabled, put the
  // template's label back. Sold-out and unavailable texts stay Dawn's.
  function initFixedLabel(wrapper) {
    if (wrapper.dataset.hisolaLabelReady) return;
    var label = wrapper.getAttribute('data-hisola-atc-label');
    var button = wrapper.querySelector('[type="submit"][name="add"]');
    var text = button && button.querySelector('span');
    if (!label || !text) return;
    wrapper.dataset.hisolaLabelReady = 'true';
    function apply() {
      if (!button.hasAttribute('disabled') && text.textContent.trim() !== label) text.textContent = label;
    }
    apply();
    new MutationObserver(apply).observe(button, { attributes: true, attributeFilter: ['disabled'], childList: true,
      subtree: true, characterData: true });
  }

  // Selected Kaching bundle on the product price (HIS-118). The previous theme's price block showed the
  // selected bundle's price, its full price and the saving; Kaching's own price update does not reach this
  // theme's price block, so the block follows the selected bundle bar (Kaching's rendered bar, read only).
  function money(text) {
    var digits = String(text || '').replace(/[^\d.,]/g, '');
    if (!digits) return null;
    var dot = digits.lastIndexOf('.');
    var comma = digits.lastIndexOf(',');
    var sep = Math.max(dot, comma);
    var decimals = sep >= 0 && digits.length - sep - 1 === 2;
    var whole = decimals ? digits.slice(0, sep) : digits;
    var value = parseFloat(whole.replace(/[.,]/g, '') + (decimals ? '.' + digits.slice(sep + 1) : ''));
    return isNaN(value) ? null : value;
  }

  function initKachingPrice(priceRoot) {
    if (priceRoot.dataset.hisolaKaching) return;
    var info = priceRoot.closest('.product__info-container');
    if (!info) return;
    priceRoot.dataset.hisolaKaching = 'waiting';
    var block = null;

    function apply() {
      var bar = block && block.querySelector('.kaching-bundles__bar--selected');
      var priceText = bar && (bar.querySelector('.kaching-bundles__bar-price') || {}).textContent;
      if (!priceText || !priceText.trim()) return;
      priceText = priceText.trim();
      var fullText = ((bar.querySelector('.kaching-bundles__bar-full-price') || {}).textContent || '').trim();
      var price = money(priceText);
      var full = money(fullText);
      var onSale = full !== null && price !== null && full > price;
      var box = priceRoot.querySelector('.price');
      if (!box) return;
      box.classList.toggle('price--on-sale', onSale);
      var set = function (el, text) { if (el && el.textContent.trim() !== text) el.textContent = text; };
      set(box.querySelector('.price__regular .price-item--regular'), priceText);
      set(box.querySelector('.price__sale .price-item--sale'), priceText);
      if (onSale) set(box.querySelector('.price__sale .price-item--regular'), fullText);
      var badge = priceRoot.querySelector('.hisola-price-badge span:last-child');
      if (badge && onSale) {
        var pct = Math.round(((full - price) / full) * 100) + '%';
        if (/\d+%/.test(badge.textContent)) set(badge, badge.textContent.replace(/\d+%/, pct));
      }
      var badgeBox = priceRoot.querySelector('.hisola-price-badge');
      if (badgeBox) badgeBox.style.display = onSale ? '' : 'none';
    }

    // The selected variant's own prices, before the bundle price replaces them (read again after Dawn
    // re-renders the block for another variant); Kaching's sticky bar shows these (initKachingSticky).
    function keepVariantPrices() {
      var box = priceRoot.querySelector('.price');
      if (!box) return;
      var onSaleNow = box.classList.contains('price--on-sale');
      var now = box.querySelector(onSaleNow ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      var was = onSaleNow ? box.querySelector('.price__sale .price-item--regular') : null;
      priceRoot.dataset.hisolaVariantNow = now ? now.textContent.trim() : '';
      priceRoot.dataset.hisolaVariantWas = was ? was.textContent.trim() : '';
    }
    keepVariantPrices();

    function attach() {
      block = info.querySelector('kaching-bundles-block');
      if (!block) return false;
      priceRoot.dataset.hisolaKaching = 'true';
      new MutationObserver(apply).observe(block, { childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class'] });
      // Dawn replaces the price block's content on a variant change: keep that variant's prices, then apply the
      // bundle price again.
      new MutationObserver(function () { keepVariantPrices(); apply(); }).observe(priceRoot, { childList: true });
      apply();
      return true;
    }

    if (attach()) return;
    var waiting = new MutationObserver(function () { if (attach()) waiting.disconnect(); });
    waiting.observe(info, { childList: true, subtree: true });
    window.setTimeout(function () { waiting.disconnect(); }, 20000);
  }

  // Kaching's sticky add-to-cart bar (HIS-118). The previous theme showed the variant's price, its struck price
  // and the price badge's saving in that bar instead of Kaching's title; this owned markup does the same,
  // reading this theme's price block (no Kaching code is changed).
  function initKachingSticky() {
    var priceRoot = document.querySelector('.product__info-container .hisola-price');
    if (!priceRoot) return;
    function fill(bar) {
      var content = bar.querySelector('.kaching-bundles-sticky-atc__content');
      if (!content) return;
      var box = content.querySelector('.hisola-ksticky');
      if (!box) {
        box = document.createElement('div');
        box.className = 'hisola-ksticky';
        box.innerHTML = '<div class="hisola-ksticky__row"><span class="hisola-ksticky__now"></span>'
          + '<span class="hisola-ksticky__was"></span></div><div class="hisola-ksticky__row">'
          + '<span class="hisola-ksticky__pill"></span></div>';
        content.appendChild(box);
      }
      var now = priceRoot.dataset.hisolaVariantNow || '';
      var was = priceRoot.dataset.hisolaVariantWas || '';
      var badge = priceRoot.querySelector('.hisola-price-badge span:last-child, .price__badge-sale');
      var pill = badge && badge.offsetParent !== null ? badge.textContent.trim() : '';
      var set = function (selector, text) {
        var el = box.querySelector(selector);
        if (el.textContent !== text) el.textContent = text;
        el.style.display = text ? '' : 'none';
      };
      set('.hisola-ksticky__now', now);
      set('.hisola-ksticky__was', was);
      set('.hisola-ksticky__pill', pill);
    }
    function scanBars() {
      Array.prototype.forEach.call(document.querySelectorAll('kaching-bundles-sticky-atc'), fill);
    }
    var queued = false;
    var update = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; scanBars(); });
    };
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var target = records[i].target;
        if (!(target.closest && target.closest('.hisola-ksticky'))) { update(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    new MutationObserver(update).observe(priceRoot, { childList: true, subtree: true, characterData: true });
    scanBars();
  }

  // A strip marked data-hisola-move-to-media sits under the product media on two-column layouts. When the media
  // column is sticky, the strip goes inside the sticky part, so it stays in view with the gallery as the long info
  // column scrolls, as on the previous theme (HIS-118).
  function placeUnderMedia(strip) {
    if (strip.dataset.hisolaPlaced || !window.matchMedia('(min-width: 750px)').matches) return;
    var info = strip.closest('product-info');
    var media = info && info.querySelector('.product__media-wrapper');
    if (!media) return;
    strip.dataset.hisolaPlaced = 'true';
    (media.querySelector('.product__column-sticky') || media).appendChild(strip);
  }

  // Video cards rest on their poster under a play control. A click plays the card with sound and mutes the others
  // (they keep playing if they were); a click on the card that has the sound mutes it and shows its control again.
  // This is how the previous theme's strip behaved (HIS-118, measured by clicking through its render).
  function initVideo(card) {
    if (card.dataset.hisolaReady) return;
    var video = card.querySelector('video');
    if (!video) return;
    card.dataset.hisolaReady = 'true';
    card.addEventListener('click', function () {
      // The card that has the sound: mute it and show its control again (it keeps playing).
      if (card.classList.contains('is-playing')) {
        video.muted = true;
        card.classList.remove('is-playing');
        return;
      }
      var strip = card.closest('[data-hisola-slider]') || card.parentElement;
      Array.prototype.forEach.call(strip.querySelectorAll('[data-hisola-video]'), function (other) {
        if (other === card) return;
        var otherVideo = other.querySelector('video');
        if (otherVideo) otherVideo.muted = true;
        other.classList.remove('is-playing');
      });
      video.muted = false;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
      card.classList.add('is-playing');
    });
  }

  // The footer spacer of the sticky bar snippet: moved to the end of the page, under the footer, then as tall as the
  // invisible bar inside it less 1px (once the fonts are in, as they decide its line wrapping) and in the footer's
  // colour. It stays empty when the page hides its sticky bars (the bar class is hidden with them).
  function placeFooterSpacer(spacer) {
    if (spacer.dataset.hisolaPlaced) return;
    spacer.dataset.hisolaPlaced = 'true';
    // A section re-rendered in the theme editor brings a new spacer; the one placed before goes.
    Array.prototype.forEach.call(document.querySelectorAll('[data-hisola-footer-spacer].is-placed'), function (old) { old.remove(); });
    document.body.appendChild(spacer);
    spacer.classList.add('is-placed');
    var size = function () {
      if (window.getComputedStyle(spacer).display === 'none') return;
      var bar = spacer.querySelector('.hisola-footer-spacer__bar');
      if (bar) spacer.style.height = Math.max(0, bar.offsetHeight - 1) + 'px';
      var footer = document.querySelector('footer.footer');
      if (footer) spacer.style.backgroundColor = window.getComputedStyle(footer).backgroundColor;
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(size, size);
    else size();
  }

  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-hisola-footer-spacer]'), placeFooterSpacer);
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-hisola-video]'), initVideo);
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-hisola-move-to-media]'), placeUnderMedia);
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-hisola-slider]'), initSlider);
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-hisola-atc-label]'), initFixedLabel);
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-hisola-sticky]'), initSticky);
    Array.prototype.forEach.call((root || document).querySelectorAll('.hisola-price'), initKachingPrice);
  }

  window.HisolaUI = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initKachingSticky);
  else initKachingSticky();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
